/* Header: sticky state + overlay menu.
   The scroll listener is passive and rAF-throttled, and writes a class only
   when the state actually changes. Reading layout on every scroll event is
   what cost the previous theme 1880ms of main-thread time. */
(function () {
  var header = document.querySelector('[data-pm-header]');
  if (header && header.classList.contains('pm-header--overlay')) {
    var stuck = false;
    var ticking = false;

    var apply = function () {
      ticking = false;
      var next = window.scrollY > 8;
      if (next === stuck) return;
      stuck = next;
      header.classList.toggle('pm-header--stuck', stuck);
    };

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      },
      { passive: true }
    );
    apply();
  }

  var menu = document.querySelector('[data-pm-menu]');
  var openBtn = document.querySelector('[data-pm-menu-open]');
  if (!menu || !openBtn) return;

  var lastFocused = null;

  var focusables = function () {
    return Array.prototype.filter.call(
      menu.querySelectorAll('a[href], button:not([disabled]), summary'),
      function (el) {
        return el.offsetParent !== null;
      }
    );
  };

  var close = function () {
    menu.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  };

  var open = function () {
    lastFocused = document.activeElement;
    menu.hidden = false;
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var f = focusables();
    if (f.length) f[0].focus();
  };

  openBtn.addEventListener('click', open);

  menu.querySelectorAll('[data-pm-menu-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  /* Close on any click outside the card. Bound to the container rather than
     the backdrop element, so it cannot be defeated by the backdrop not
     rendering, which is exactly what happened to the scrim div. */
  menu.addEventListener('click', function (event) {
    var card = menu.querySelector('.pm-menu__card');
    if (card && !card.contains(event.target)) close();
  });

  document.addEventListener('keydown', function (event) {
    if (menu.hidden) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();

/* --pm-header-h: the header group is sticky at top 0, and several sections
   pin under it (PLP category row, PLP filter bar). The variable was read in
   two places and never defined, so they all fell back to 58px and pinned
   UNDER a header that is ~80px on phones and ~99px on desktop. Measure it and
   publish it, so the offsets follow the ticker, the logo size and the band. */
(function () {
  var group = document.querySelector('.shopify-section-group-header-group');
  if (!group) return;
  var publish = function () {
    var h = Math.round(group.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--pm-header-h', h + 'px');
  };
  publish();
  if (window.ResizeObserver) new ResizeObserver(publish).observe(group);
  window.addEventListener('resize', publish, { passive: true });
  window.addEventListener('load', publish);
})();
